import type { ReactNode } from 'react';
import type { TabProductMap } from 'reactApp/sections/QuotaLanding/MultiTariffsList/hooks/useUpsaleProductsMapping';
import {
    type MultiTariffDoubleUpsaleArgs,
    type MultiTariffUpsaleRadioType,
    MultiTariffUpsaleRadioTypeTranslate,
} from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/models/MultiTariffUpsaleDialog.model.types';
import { MultiTariffUpsaleModelBase } from 'reactApp/sections/QuotaLanding/multiTariffUpsaleDialog/models/MultiTariffUpsaleDialogBase.model';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

export class FamilyAndBusinessMultiTariffUpsaleDialogModel extends MultiTariffUpsaleModelBase {
    protected tabSecondaryProductMap: TabProductMap;

    constructor({ tabSecondaryProductMap, ...props }: MultiTariffDoubleUpsaleArgs) {
        super(props);
        this.tabSecondaryProductMap = tabSecondaryProductMap;
    }

    override getTitle(): string {
        return 'Есть ещё два тарифа, в которых возможностей больше';
    }

    override getTitleDescription(): string {
        return 'Семейный тариф: общие ГБ и функции для четверых, без доступа к личному. Тариф для работы: отмена отправки писем, красивый адрес, нейросеть в Почте';
    }

    override getPriorityCardLabelText(): string {
        return 'Семейный';
    }

    override getSecondaryCardLabelText(): string {
        switch (this.activeTab) {
            case ETabsName.basic:
                return 'Минимальный';
            case ETabsName.advanced:
            default:
                return 'Основной';
        }
    }

    override getSecondaryCardLabelVisible(): boolean {
        return true;
    }

    override getPriorityCardTopTitle(): ReactNode {
        return `+${this.product.space.value}`;
    }

    override getSecondaryCardTopTitle(): ReactNode {
        return `+${this.product.space.value}`;
    }

    getFirstAlternativeCardTopTitle() {
        return `+${this.product.space.value}`;
    }

    getFirstAlternativeCardTitle() {
        const firstAlternativeProduct = this.getFirstAlternativeProduct();
        return this.getProductPriceString(firstAlternativeProduct);
    }

    getFirstAlternativeCardDescription() {
        const firstAlternativeProduct = this.getFirstAlternativeProduct();
        return this.getProductDescription(firstAlternativeProduct);
    }

    getFirstAlternativeCardLabelText() {
        return 'Для работы';
    }

    getFirstAlternativeProduct() {
        const period = this.isMonthActivePeriod() ? 'month' : 'year';
        return this.tabSecondaryProductMap?.[this.activeTab]?.[period]?.[this.product.id];
    }

    getDwh(selected: MultiTariffUpsaleRadioType) {
        const dwh = super.getDwh(selected);
        return { ...dwh, action: 'modal-upsale', selectedType: MultiTariffUpsaleRadioTypeTranslate[selected] };
    }
}
